import { theme } from '@features/executive-report/domain/theme';
import { ShapeProps } from '@features/powerpoint';
import { SECTION_X_OFFSET } from './layout';

type GreenLineOptions = ShapeProps['options'];

const greenLine = (options: GreenLineOptions): ShapeProps => ({
  shapeName: 'line',
  options: {
    line: {
      color: theme.colors.inmarketGreen,
      width: 1,
    },
    h: 0,
    w: 5.86,
    x: 0.66,
    y: 2.4,
    ...options,
  },
});

type BoxOptions = {
  fillColor?: string;
  shapeOptions?: ShapeProps['options'];
};

const transparentBox = (options: BoxOptions): ShapeProps => ({
  shapeName: 'rect',
  options: {
    fill: {
      color: options.fillColor ?? theme.colors.inmarketGreen,
      transparency: 86,
    },
    h: 0.56,
    w: 4.53,
    x: 1.4,
    y: 2.7,
    ...options.shapeOptions,
  },
});

export const shapes: ShapeProps[] = [
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: theme.colors.darkGray,
        transparency: 49,
      },
      h: 0.72,
      w: 3.31,
      x: 9.74,
      y: 1.06,
    },
  },
  greenLine({ x: 0.66 }),
  transparentBox({ shapeOptions: { x: 1.4 } }),
  greenLine({ x: 0.66 + SECTION_X_OFFSET }),
  transparentBox({ shapeOptions: { x: 1.4 + SECTION_X_OFFSET } }),
];
